export default __webpack_public_path__ + "f2a04d977c11ca8fbd8275794a4d9b40.png";